module.exports = __webpack_public_path__ + "static/media/lapita_text_02.d0efc4d7.jpg";